import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export const Hero = () => {
  return (
    <section id="hero" className="relative flex min-h-[100vh] items-center overflow-hidden pt-16">
      <div className="grid-texture absolute inset-0" aria-hidden="true" />

      <div className="container-xl relative z-10 py-20">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
          className="max-w-2xl"
        >
          <p className="eyebrow-mono mb-6">// Obsessional Documentary Filmmaking</p>

          <h1 className="font-display text-6xl font-semibold leading-[0.98] text-foreground sm:text-7xl lg:text-8xl">
            Story as
            <br />
            <span className="relative inline-block">
              practice.
              <span className="absolute left-0 -bottom-4 h-[5px] w-full bg-foreground sm:-bottom-5 sm:h-[7px] lg:-bottom-7" />
            </span>
          </h1>

          <p className="mt-8 max-w-md text-base leading-relaxed text-foreground/75 sm:text-lg">
            Long-form documentary features from India and South East Asia —
            told with the care, time and craft only a dedicated team can bring.
          </p>
        </motion.div>
      </div>

      <div className="absolute inset-x-0 bottom-8 z-10 flex flex-col items-center gap-2">
        <span className="font-mono-brand text-[11px] uppercase tracking-[0.3em] text-foreground/50">
          Scroll
        </span>
        <ChevronDown className="h-4 w-4 animate-scroll-cue text-foreground/50" />
      </div>
    </section>
  );
};
